import BaseRequest from './BaseRequest';
import { API_URL } from '../config/config';

const BASE_URL = `${API_URL}/catalog-sheet`;
const CatalogSheet = () => {
    return {
        getFormConfig(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${BASE_URL}/get-form-config`,
                { headers: BaseRequest.privateHeaders() },
                cancelToken,
            );
        },
        save(data, cancelToken = null) {
            return BaseRequest.axiosInst.post(
                `${BASE_URL}/save`,
                data,
                {
                    headers: {
                        ...BaseRequest.privateHeaders(),
                        'Content-Type': 'multipart/form-data',
                    },
                },
                cancelToken,
            );
        },
        getPdfViewPermission(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${BASE_URL}/pdf-view-permission`,
                { headers: {...BaseRequest.privateHeaders()}, cancelToken },
            );
        }
    };
};

export default CatalogSheet();
